const customFadeInTopText = ({
	elem = null,
	parentElem,
	index = 0,
	dividedText = false,
}) => {
	if (elem || elem.length > 0) {
		window.customScrollbarInstance?.gsap?.fromTo(
			elem,
			{
				y: 25,
				opacity: 0,
			},
			{
				y: 0,
				opacity: 1,
				duration: 0.75,
				stagger: 0.25,
				ease: "power2.inOut",
				delay: (index + 1) * 0.25,
				scrollTrigger: {
					trigger: parentElem,
					start: "top 85%",
				},
			},
		);
	}
};

const customFadeInTopElem = ({
	elem,
	parentElem,
	index = 0,
	yStart = "25px",
	// start = "top 25%",
	start = "top center",
	delay = null,
}) => {
	window.customScrollbarInstance?.gsap?.fromTo(
		elem,
		{
			y: yStart,
			opacity: 0,
		},
		{
			y: "0",
			opacity: 1,
			duration: 0.75,
			stagger: 0.15,
			ease: "power2.inOut",
			delay: delay ? delay : index * 0.25,
			scrollTrigger: {
				trigger: parentElem,
				start,
			},
			onComplete: () => {
				elem?.classList?.add("animated");
			},
		},
	);
};

const initTextAnimations = ({ blocks }) => {
	blocks?.forEach((block) => {
		const animatedItems = block.querySelectorAll(
			".animated-block__item:not(.typed-not-auto)",
		);
		animatedItems?.forEach((item, index) => {
			if (item.classList.contains("animated-block__item--divided-text")) {
				jQuery(item).splitLines({
					tag: "<span class='sentence'>",
					keepHtml: true,
				});

				customFadeInTopText({
					elem: item,
					parentElem: block,
					index,
				});

				customFadeInTopText({
					elem: item.querySelectorAll(".sentence"),
					parentElem: block,
					index,
				});
			} else {
				customFadeInTopText({ elem: item, parentElem: block, index });
			}
		});
	});
};

export { customFadeInTopText, customFadeInTopElem, initTextAnimations };
